import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faPenToSquare, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { SmartListSource } from "@/pages/Private/pages/List/schema/list";

import { SourceCriteriaChips } from "./SourceCriteriaChips";

interface SourceItemProps {
	source: SmartListSource;
	onEdit: (source: SmartListSource) => void;
	onRemove: (source: SmartListSource) => void;
	isRemoving?: boolean;
}

export const SourceItem: FunctionComponent<SourceItemProps> = ({
	source,
	onEdit,
	onRemove,
	isRemoving,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.reengage.${key}`);

	return (
		<div className="flex gap-3 items-start bg-white border border-border rounded-lg p-3.5 mb-2">
			<div className="flex-1 min-w-0">
				<div className="text-[13px] font-semibold text-text mb-0.5 truncate">{source.name}</div>
				<div className="text-xs text-text-meta">{ts("rechecksDaily")}</div>
				<SourceCriteriaChips filter={source.filter} />
			</div>
			<div className="flex gap-1">
				<button
					aria-label={ts("edit")}
					className="w-7 h-7 flex items-center justify-center bg-white border border-border rounded-md text-text-meta hover:bg-background-light hover:text-text"
					title={ts("edit")}
					type="button"
					onClick={() => onEdit(source)}
				>
					<Icon className="w-3.5 h-3.5" icon={faPenToSquare} />
				</button>
				<button
					aria-label={ts("remove")}
					className="w-7 h-7 flex items-center justify-center bg-white border border-border rounded-md text-text-meta hover:border-status-error hover:bg-status-error-light hover:text-status-error disabled:opacity-50"
					disabled={isRemoving}
					title={ts("remove")}
					type="button"
					onClick={() => onRemove(source)}
				>
					<Icon className="w-3.5 h-3.5" icon={faTrashCan} />
				</button>
			</div>
		</div>
	);
};
